'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var debug = require('debug')('knack-field-predictor-base');
var BasePredictor = /*#__PURE__*/function () {
  function BasePredictor(type, default_format) {
    _classCallCheck(this, BasePredictor);
    debug("Instantiating BasePredictor with ".concat(JSON.stringify(arguments), " for ").concat(this.constructor.name));
    if (!type) {
      throw new Error("".concat(this.constructor.name, " must provide a type argument in the constructor"));
    }
    this._type = type;
    this._default_format = default_format;
  }
  return _createClass(BasePredictor, [{
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "is_match",
    get: function get() {
      return this._is_match;
    },
    set: function set(is_match) {
      if (typeof is_match !== 'boolean') {
        throw new Error("".concat(this.constructor.name, " - is_match may only be set to true or false"));
      }
      this._is_match = is_match;
    }
  }, {
    key: "format",
    set: function set(format) {
      if (!format) {
        throw new Error("".concat(this.constructor.name, " - format cannot be set to null or undefined"));
      }
      this._format = format;
    }
  }, {
    key: "prediction",
    get: function get() {
      if (!this.is_match) {
        return;
      }
      var prediction_result = {
        type: this.is_match ? this._type : null,
        format: this._format || this._default_format || null
      };
      debug("Returning prediction: ".concat(JSON.stringify(prediction_result)));
      return prediction_result;
    }
  }, {
    key: "predict",
    value: function predict() {
      throw new Error("".concat(this.constructor.name, " must implement the predict function"));
    }
  }]);
}();
module.exports = BasePredictor;